export const PAGESIZE = 30;

export const httpGet = async (url, user) => {
    return httpRequest('GET', url, user);
}

export const httpPost = async (url, user, data) => {
    return httpRequest('POST', url, user, data);
}

export const httpPut = async (url, user, data) => {
    return httpRequest('PUT', url, user, data);
}

export const httpDelete = async (url, user) => {
    return httpRequest('DELETE', url, user);
}

const httpRequest = async (method, url, user, data) => {
    const options = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': user ? `Bearer ${user.access_token}` : undefined,
        },
        body: data ? JSON.stringify(data) : undefined,
    }

    const res = await fetch(url, options);
    ensureResponseStatus(res);

    try {
        return await res.json();
    } catch {
        return {};
    }
}

// Downloads a file the API only serves with a bearer token, so a plain link can't fetch it.
// A refusal with a problem detail (e.g. "too many rows, narrow the filters") becomes the error message.
export const httpGetFile = async (url, user, fileName) => {
    const res = await fetch(url, { headers: user ? getAuthorizationHeadersOnly(user) : {} });

    if (res.status === 400) {
        const problem = await res.json().catch(() => null);
        throw new Error(problem?.detail ?? `Http error occurred (${res.status})`);
    }
    ensureResponseStatus(res);

    const objectUrl = URL.createObjectURL(await res.blob());
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
};

export const getAuthorizationHeaders = (user) => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.access_token}`,
});

export const getAuthorizationHeadersOnly = (user) => ({
    'Authorization': `Bearer ${user.access_token}`,
});

let unauthorizedHandler = null;

// Registered from the store, so this helper stays free of store imports.
export const setUnauthorizedHandler = (handler) => {
    unauthorizedHandler = handler;
};

export const ensureResponseStatus = (res, acceptStatusCodes) => {
    if (res.status < 200 || res.status >= 400) {
        if (acceptStatusCodes && acceptStatusCodes.find((code) => code === res.status)) {
            return;
        }

        // The token was rejected: re-authenticate instead of only showing an error.
        if (res.status === 401 && unauthorizedHandler) {
            unauthorizedHandler();
        }

        console.error(res);
        throw new Error(`Http error occurred (${res.status})`);
    }
};
